import _ from 'lodash';
import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import withReplace from 'shared/redux/helpers/vod-settings-replace';
import { update } from '@wix/wix-vod-api/dist/src/private/settings/settings';

const ACTIONS = createAsyncActions('SERVER.VOD-SETTINGS.UPDATE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function(settings) {
  return function(dispatch, getState) {
    const { vodSettings } = getState();

    if (_.isEmpty(settings)) {
      return Promise.resolve(vodSettings);
    }

    settings = _.mergeWith({}, vodSettings, settings, withReplace);

    if (_.isEqual(settings, vodSettings)) {
      return Promise.resolve(vodSettings);
    }

    dispatch(START(settings));

    return update(settings).then(
      function(result) {
        dispatch(SUCCESS(settings, result));
        return result;
      },

      function() {
        dispatch(
          FAIL(settings, null, {
            analytics: { type: 'error', name: 'shared.vod-settings.update' },
          }),
        );
      },
    );
  };
}
